import { render, staticRenderFns } from "./stkinfo_tmpl.vue?vue&type=template&id=1f4776ae&scoped=true&"
import script from "./stkinfo_tmpl.vue?vue&type=script&lang=js&"
export * from "./stkinfo_tmpl.vue?vue&type=script&lang=js&"
import style0 from "./stkinfo_tmpl.vue?vue&type=style&index=0&id=1f4776ae&scoped=true&lang=less&"
import style1 from "./stkinfo_tmpl.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4776ae",
  null
  
)

export default component.exports